<po-page-list
  p-title="Programação Carregamento - Lista"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings">
  <po-container class="po-md-12">
    <form #formCodigoCarregamento="ngForm">
      <po-combo class="po-lg-2 po-md-2 po-sm-2"
        name="codigoCarregamento"
        p-label="Código Carregamento"
        [(ngModel)]="codigoCarregamento"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        [p-options]="optionsComboBoxCarregamento"
        p-filter-minlength="4"
        [p-disabled]="bloqueiaAcao"
        [p-required]="true">
      </po-combo>
    </form>
    <po-button class="po-xl-1 po-lg-2 po-mt-3"
      p-label="Adicionar"
      (p-click)="bttnAdicionar()"
      [p-disabled]="bloqueiaAcao || formCodigoCarregamento.invalid"
      p-kind="primary">
    </po-button>
    <po-button class="po-xl-1 po-lg-2 po-mt-3"
      p-label="Remover"
      (p-click)="bttnRemover()"
      [p-disabled]="bloqueiaAcao"
      p-danger="true">
    </po-button>
    <po-button class="po-xl-1 po-lg-2 po-mt-3"
      p-label="Gerar Excel"
      (p-click)="bttnExcel()"
      p-kind="secondary">
    </po-button>
     <po-button class="po-xl-2 po-lg-2 po-mt-3"
      p-label="Imp. Romaneios"
      p-icon="po-icon-print"
      (p-click)="bttnEtiquetaClienteSelecionados()"
      [p-disabled]="bloqueiaAcao">
    </po-button>
     <po-button class="po-xl-2 po-lg-2 po-mt-3"
      p-label="Email.Roman - Assig."
      p-icon="po-icon-print"
      (p-click)="bttnEmailAssiginados()"
      [p-disabled]="bloqueiaAcao">
    </po-button>
    <po-input  class="po-xl-2 po-lg-2 po-mt-3"
      p-upper-case="true"
      name="inputPesquisar"
      p-icon="po-icon-search"
      p-placeholder="Pesquisar"
      [(ngModel)]="inputPesquisar"
      (p-change-model)="changeFiltro($event)">
    </po-input>
  </po-container>
  <po-table class="po-md-12 po-mt-1"
    p-container="shadow"
    p-height="550"
    [p-striped]="true"
    [p-selectable]="true"
    [p-selectable-entire-line]="false"
    (p-selected)="selecionaRegistro()"
    (p-unselected)="selecionaRegistro()"
    (p-all-selected)="selecionaRegistro()"
    (p-all-unselected)="selecionaRegistro()"
    [p-hide-columns-manager]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    [p-actions]="tabelaPrincipalActions">
  </po-table>
</po-page-list>

<po-modal #dataHoraCarregamentoModal p-title="Editar data e hora do Carregamento" p-size="sm" p-hide-close="true">
  <form #formDataHoraCarregamento="ngForm">
    <po-datepicker class="po-md-6"
      name="editCZ00DTACAR"
      p-label="Data"
      [(ngModel)]="editCZ00DTACAR"
      [p-iso-format]="formatBasic"
      p-required="true">
    </po-datepicker>
    <po-input class="po-md-6"
      name="editCZ00HRACAR"
      p-label="Hora"
      [(ngModel)]="editCZ00HRACAR"
      p-mask="99:99:99"
      p-required="true"
      p-minlength="8">
    </po-input>
  </form>
  <po-modal-footer>
    <po-button class="po-md-2" p-label="Fechar"     p-danger="true"   (p-click)="closeModalDataHoraCarregamento()"></po-button>
    <po-button class="po-md-2" p-label="Confirmar"  p-kind="primary"  (p-click)="ConfirmaModalDataHoraCarregamento()" [p-disabled]="formDataHoraCarregamento.invalid"></po-button>
  </po-modal-footer>
</po-modal>

<po-modal #editarDadosEtapaModal p-title="Editar Dados Romaneio" [p-primary-action]="salvarDadosRomaneio">
  <form #formEditarDadosRomaneio="ngForm">
    <po-divider class="po-md-12" p-label="1ª Etapa"></po-divider>
    <po-lookup class="po-md-6"
      name="CZ00CAMICP"
      p-label="Truck Company / Transportadora"
      [(ngModel)]="dadosEtapasRomaneio.CZ00CAMICP"
      p-field-label="CA4NOME"
      p-field-value="CA4COD"
      [p-columns]="transportadoraLookupColumns"
      [p-field-format]="transportadoraService.getFieldFormater"
      [p-filter-service]="transportadoraService"
      [p-advanced-filters]="transportadoraService.getAdvancedFilter"
      [p-literals]="{ modalTitle: 'Transportadora' }">
    </po-lookup>
    <po-input class="po-md-6"
      name="CZ00PROCES"
      p-label="Process / Processo"
      [(ngModel)]="dadosEtapasRomaneio.CZ00PROCES">
    </po-input>
    <po-input class="po-md-6"
      name="CZ00NCERT"
      p-label="Nº Certificado"
      [(ngModel)]="dadosEtapasRomaneio.CZ00NCERT">
    </po-input>
    <po-divider class="po-md-12" p-label="2ª Etapa"></po-divider>
    <po-lookup class="po-md-6"
      name="CZ00PLACA"
      p-label="Truck Plate / Placa Veículo"
      [(ngModel)]="dadosEtapasRomaneio.CZ00PLACA"
      p-field-value="CDA3PLACA"
      p-field-label="CDA3DESC"
      [p-columns]="veiculoLookupColumns"
      [p-field-format]="veiculoLookupService.getFieldFormater"
      [p-filter-service]="veiculoLookupService"
      [p-advanced-filters]="veiculoLookupService.getAdvancedFilter"
      [p-literals]="{ modalTitle: 'Veículo' }"
      [p-required]="true"
      [p-disabled]="bloqueiaPlaca">
    </po-lookup>
    <po-input class="po-md-6"
      name="CZ00COTNER"
      p-label="Container / Container"
      [(ngModel)]="dadosEtapasRomaneio.CZ00COTNER">
    </po-input>
    <po-number class="po-md-6"
      name="NZ00TARA"
      p-label="Tare / Tara"
      [(ngModel)]="dadosEtapasRomaneio.NZ00TARA">
    </po-number>
    <po-input class="po-md-6"
      name="CZ00SELOD"
      p-label="Definitive Seal / Lacre Definitivo"
      [(ngModel)]="dadosEtapasRomaneio.CZ00SELOD">
    </po-input>
    <po-input class="po-md-6"
      name="CZ00SELOP"
      p-label="Provisional Seal / Lacre Provisório"
      [(ngModel)]="dadosEtapasRomaneio.CZ00SELOP">
    </po-input>
    <po-datepicker class="po-md-3"
      name="DZ00DTACAR"
      p-label="Data de Carregamento"
      [(ngModel)]="dadosEtapasRomaneio.DZ00DTACAR">
    </po-datepicker>
    <po-input class="po-md-3"
      name="CZ00HRACAR"
      p-label="Hora do Carregamento"
      [(ngModel)]="dadosEtapasRomaneio.CZ00HRACAR"
      p-mask="99:99:99">
    </po-input>
    <po-input class="po-md-6"
      name="CZ00TERMIN"
      p-label="Terminal de Apoio"
      [p-maxlength]="50"
      [(ngModel)]="dadosEtapasRomaneio.CZ00TERMIN">
    </po-input>
    <po-datepicker class="po-md-3"
      name="DZ00DTETER"
      p-label="Data Entrada Terminal"
      [(ngModel)]="dadosEtapasRomaneio.DZ00DTETER">
    </po-datepicker>
    <po-datepicker class="po-md-3"
      name="DZ00DTEPOR"
      p-label="Data Entrada Porto"
      [(ngModel)]="dadosEtapasRomaneio.DZ00DTEPOR">
    </po-datepicker>
    <po-divider class="po-md-12" p-label="Outros dados"></po-divider>
    <po-number class="po-md-6"
      name="NZ00PESLIM"
      p-label="Limit Weight / Peso Limite"
      [(ngModel)]="dadosEtapasRomaneio.NZ00PESLIM">
    </po-number>
    <po-input class="po-md-6"
      name="CZ00FRETCP"
      p-label="Shipping Company"
      [(ngModel)]="dadosEtapasRomaneio.CZ00FRETCP">
    </po-input>
  </form>
</po-modal>

<po-modal #advancedFilterModal p-title="Filtros" p-size="sm" [p-primary-action]="advancedFilterPrimaryAction">
  <form #formFiltroPrincipal="ngForm">
    <po-datepicker class="po-md-6"
      name="DZ00DATA_DE"
      p-label="Data De"
      [(ngModel)]="filtroPrincipal.dados.DZ00DATA_DE"
      [p-iso-format]="formatExtended">
    </po-datepicker>
    <po-datepicker class="po-md-6"
      name="DZ00DATA_ATE"
      p-label="Data Até"
      [(ngModel)]="filtroPrincipal.dados.DZ00DATA_ATE"
      [p-iso-format]="formatExtended">
    </po-datepicker>
    <po-input class="po-md-6"
      name="CZ00COD"
      p-label="Código Romaneio"
      p-maxlength="6"
      [(ngModel)]="filtroPrincipal.dados.CZ00COD">
    </po-input>
    <po-input class="po-md-6"
      name="CZ07CODIGO"
      p-label="Código Carregamento"
      p-maxlength="6"
      [(ngModel)]="filtroPrincipal.dados.CZ07CODIGO">
    </po-input>
    <po-select class="po-md-6"
      name="CZ00STATUS"
      p-label="Status Romaneio"
      [(ngModel)]="filtroPrincipal.dados.CZ00STATUS"
      [p-options]="optionsStatusRomaneio">
    </po-select>
    <po-input class="po-md-6"
      name="CZ00CLIENT"
      p-label="Cliente"
      [(ngModel)]="filtroPrincipal.dados.CZ00CLIENT"
      p-maxlength="6">
    </po-input>
    <po-input class="po-md-6"
      name="CZ00PROCES"
      p-label="Processo"
      [(ngModel)]="filtroPrincipal.dados.CZ00PROCES">
    </po-input>
    <po-input class="po-md-6"
      name="CEE7PEDIDO"
      p-label="P.O. Number"
      [(ngModel)]="filtroPrincipal.dados.CEE7PEDIDO">
    </po-input>
  </form>
</po-modal>

<po-modal #modalInfCertificado p-title="Informações do Certificado" p-size="md" p-hide-close="true">
  <div class="po-md-6">
    <po-table class="po-md-12"
      [p-height]="217"
      p-container="shadow"
      [p-columns]="tabelaUrColumns"
      [p-items]="tabelaUrItens"
      (p-selected)="URSelecionada($event)"
      (p-unselected)="URSelecionada($event)"
      p-spacing="small"
      [p-striped]="true"
      [p-selectable]="true"
      [p-single-select]="true"
      [p-hide-select-all]="true"
      [p-hide-table-search]="true"
      [p-hide-columns-manager]="true">
    </po-table>
  </div>
  <form #formInfCertificado="ngForm">
    <div class="po-md-6">
      <po-select class="po-md-6"
        name="tratamento"
        p-label="Tratamento"
        [p-options]="optionsTratamento"
        [(ngModel)]="dadosInfCertificado.CZEXTKD"
        [p-required]="true">
      </po-select>
      <po-select class="po-md-6"
        name="assinatura"
        p-label="Técnico/Assinatura"
        [p-options]="optionsTecnico"
        [(ngModel)]="dadosInfCertificado.CZEXTEC"
        [p-required]="true">
      </po-select>
      <po-textarea class="po-md-12"
        name="informacaolote"
        p-label="Informações Lote"
        [(ngModel)]="dadosInfCertificado.CZEXINF"
        p-rows="5">
      </po-textarea>
    </div>
  </form>
  <po-modal-footer>
    <po-button p-label="Voltar"       p-danger="true"     (p-click)="closeModalInfCertificado()"></po-button>
    <po-button p-label="Gravar"       p-kind="primary"    (p-click)="gravarModalInfCertificado()" [p-disabled]="formInfCertificado.invalid"></po-button>
    <po-button p-label="Certificados" p-kind="secondary"  (p-click)="certificadosModalInfCertificado()" [p-disabled]="dadosInfCertificado.NQTDZ02UR === 0"></po-button>
  </po-modal-footer>
</po-modal>
